export const SettingsIcon = () => (
  <svg fill="none" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.5 9.33333V10.6667H4.5V9.33333H0.5ZM0.5 1.33333V2.66667H7.16667V1.33333H0.5ZM7.16667 12V10.6667H12.5V9.33333H7.16667V8H5.83333V12H7.16667ZM3.16667 4V5.33333H0.5V6.66667H3.16667V8H4.5V4H3.16667ZM12.5 6.66667V5.33333H5.83333V6.66667H12.5ZM8.5 4H9.83333V2.66667H12.5V1.33333H9.83333V0H8.5V4Z"
      fill="currentColor"
    />
  </svg>
)
